import { Box, PressableIcon } from '@betty/moonlight';
import { BottomSheet } from '@betty/navigation';
import { memo, useCallback } from 'react';
import { ShopItemType } from '../../state/items/items.types';

function ShopItemInfo(item: ShopItemType) {
  const { name, description, type, mysteryBoxConfiguration } = item;

  const onInfo = useCallback(
    () =>
      type === 'MysteryBox' && mysteryBoxConfiguration?.itemDrops
        ? BottomSheet.open({
            title: name,
            namespace: 'shop',
            type: 'MysteryBoxInfo',
            data: {
              description,
              itemDrops: mysteryBoxConfiguration.itemDrops,
            },
          })
        : BottomSheet.open({
            namespace: 'shop',
            type: 'ShopItemInfo',
            title: name,
            data: {
              text: description,
            },
          }),
    [name, description, type, mysteryBoxConfiguration],
  );

  return (
    <Box
      position="absolute"
      zIndex={10}
      bottom="space-200"
      right="space-200"
      padding="space-100"
      borderRadius="radius-full"
      backgroundColor="primaryBackgroundHover"
    >
      <PressableIcon
        name="info"
        color="darkSurfacePrimary"
        width="space-500"
        height="space-500"
        onPress={onInfo}
      />
    </Box>
  );
}

export default memo(ShopItemInfo);
